/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { Grid } from 'antd';

import { MimicLogo } from '@/components/MimicLogo';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Divider } from '@/primitives/Divider';
import { Flex } from '@/primitives/Flex';
import { Footer } from '@/primitives/Footer';
import { Link } from '@/primitives/Link';
import { Space } from '@/primitives/Space';
import { Text } from '@/primitives/Text';
import { tokens } from '@/theme';
import './SupportFooter.css';

const { useBreakpoint } = Grid;

export function SupportFooter() {
  const { t } = useMimicTranslation('footer');
  const screens = useBreakpoint();
  const telephone = '+1 (650) 698-2400';
  const email = 'support@mimic.com';

  return (
    <Footer className="support-footer">
      <Flex justify="space-between" gap="xs" wrap>
        <div className="support-footer-contact-container">
          <Text type="subtle">{t('contactUs')}</Text>
          <div className="support-footer-contacts">
            <Link href={`mailto:${email}`}>
              <Space size="xxs">
                <MailOutlined />
                {email}
              </Space>
            </Link>
            {screens.sm && <Divider vertical dark />}
            <Link href={`tel:${telephone}`}>
              <Space size="xxs">
                <PhoneOutlined />
                {telephone}
              </Space>
            </Link>
          </div>
        </div>
        <div className="support-footer-copyright">
          <MimicLogo width="3.5rem" height="1rem" color={tokens.color.text.textDefault} />
          <Text type="subtle">{t('copyright')}</Text>
        </div>
      </Flex>
    </Footer>
  );
}
